var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPaymentMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 340,
    viewBox: "0 0 450 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_2282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6322 21.5461L91.1473 12.6366C90.8885 11.0819 90.9715 9.48944 91.3903 7.97C91.8092 6.45055 92.554 5.04054 93.5728 3.83799C94.5916 2.63544 95.8602 1.6692 97.2902 1.00642C98.7201 0.343637 100.277 0.000217398 101.853 3.7982e-05H347.68C349.212 -0.0040779 350.725 0.326365 352.116 0.968251C353.506 1.61014 354.739 2.54797 355.729 3.71618C356.719 4.88438 357.442 6.25475 357.847 7.73145C358.252 9.20816 358.33 10.7555 358.075 12.2654L356.026 24.4417L92.6322 21.5461Z",
    fill: "#00E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M113.822 135.038L106.769 253.341C106.633 255.63 106.967 257.922 107.75 260.078C108.532 262.233 109.747 264.206 111.32 265.875C112.893 267.543 114.79 268.873 116.896 269.782C119.001 270.691 121.27 271.16 123.563 271.16H325.897C328.597 271.161 331.268 270.605 333.744 269.527C336.219 268.449 338.445 266.872 340.284 264.894C342.122 262.916 343.532 260.581 344.427 258.033C345.322 255.486 345.681 252.781 345.483 250.089L337.212 137.072L113.822 135.038Z",
    fill: "#535C70"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.606 151.208L125.775 219.514H326.105L318.843 151.208H132.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.686 184.441C189.686 184.441 176.039 196.097 186.864 209.15C197.689 222.202 201.476 241.001 218.374 230.191C235.272 219.381 225.012 197.33 225.012 197.33L189.686 184.441Z",
    fill: "#FFC6B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M189.686 184.441C189.686 184.441 176.039 196.097 186.864 209.15C197.689 222.202 201.476 241.001 218.374 230.191C235.272 219.381 225.012 197.33 225.012 197.33L189.686 184.441Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.822 135.038L92.6326 21.546C92.4037 20.3201 92.4475 19.0587 92.761 17.8516C93.0746 16.6445 93.6501 15.5213 94.4467 14.5617C95.2433 13.6021 96.2414 12.8297 97.3702 12.2994C98.4989 11.769 99.7307 11.4938 100.978 11.4932H345.082C346.688 11.493 348.275 11.8426 349.733 12.5177C351.19 13.1927 352.483 14.177 353.521 15.4021C354.56 16.6272 355.319 18.0638 355.747 19.612C356.174 21.1602 356.259 22.7829 355.996 24.3673L337.212 137.072L113.822 135.038Z",
    fill: "#535C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.684 28.1538L126.637 119.446H321.398L335.074 28.1538H111.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.045,
    d: "M181.609 88.3225H164.116L128.85 208.927L186.093 219.514C186.093 219.514 178.134 254.321 195.582 271.189H230.076L238.778 212.61L181.609 88.3225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.338 218.487L283.363 76.1765L191.421 51.6094L153.395 193.92L245.338 218.487Z",
    fill: "#FFD008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.331 202.51L249.477 138.544L234.223 134.455L217.077 198.422L232.331 202.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M210.645 102.806L216.849 79.6594C217.664 76.6206 215.861 73.4969 212.822 72.6824L208.573 71.5435C205.534 70.729 202.41 72.5321 201.596 75.5709L195.392 98.7175C194.577 101.756 196.38 104.88 199.419 105.695L203.668 106.833C206.707 107.648 209.831 105.845 210.645 102.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M189.529 185.138L206.572 121.356C207.381 118.329 205.583 115.22 202.556 114.412L198.324 113.281C195.297 112.472 192.188 114.27 191.38 117.297L174.337 181.078C173.528 184.105 175.326 187.214 178.353 188.023L182.585 189.153C185.612 189.962 188.721 188.164 189.529 185.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M253.329 105.577C259.078 105.577 263.738 100.917 263.738 95.168C263.738 89.4192 259.078 84.7588 253.329 84.7588C247.58 84.7588 242.92 89.4192 242.92 95.168C242.92 100.917 247.58 105.577 253.329 105.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M203.332 179.763C203.332 179.763 189.226 182.332 192.938 204.487L209.524 208.942L203.332 179.763Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M250.345 119.446C256.094 119.446 260.754 114.786 260.754 109.037C260.754 103.288 256.094 98.6277 250.345 98.6277C244.596 98.6277 239.936 103.288 239.936 109.037C239.936 114.786 244.596 119.446 250.345 119.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.449 292.706L216.311 271.353C216.311 271.353 202.263 260.409 206.436 230.429C210.609 200.448 197.928 200.27 202.575 181.991C207.223 163.712 226.735 177.878 231.486 199.424C236.238 220.97 254.102 189.029 254.102 189.029C254.102 189.029 274.445 197.404 267.733 238.64C261.021 279.876 263.353 292.676 263.353 292.676L215.449 292.706Z",
    fill: "#FFC6B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.866 45.0371H144.768V88.3223H302.866V45.0371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.208 88.3224H147.426L144.768 82.2046H302.866L300.208 88.3224Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.396 280.47L269.143 276.312L275.959 340H201.595L205.396 280.47Z",
    fill: "#00E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M181.608 88.3225L177.792 102.578L277.355 98.6278L280.102 88.3225H181.608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.515 48.8389L183.702 63.9998H259.433L264.852 48.8389H179.515Z",
    fill: "#00E0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_2282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 340,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPaymentMethod);
export default __webpack_public_path__ + "static/media/AddPaymentMethod.67931242ab99f707b74210c84e49abe5.svg";
export { ForwardRef as ReactComponent };